export default {
  apiKey: "AIzaSyAMK3kstYArhRYN7J461JFVAF1PC7uQzOg",
  authDomain: "jowin-1434c.firebaseapp.com",
  projectId: "jowin-1434c",
  storageBucket: "jowin-1434c.appspot.com",
  messagingSenderId: "30689936205",
  appId: "1:30689936205:web:cfffd9ef080dfab04ead04",
  measurementId: "G-KR8SXZED5M"
};
